"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Toast = exports.ToastContent = exports.ToastRegion = exports.ToastQueue = void 0;
var styled_1 = __importDefault(require("@emotion/styled"));
var React = __importStar(require("react"));
var react_aria_components_1 = require("react-aria-components");
var Flex_1 = require("../Flex");
var Typography_1 = require("../Typography");
var icons_1 = require("../icons");
var screenSizes_1 = require("../screenSizes");
var theme_1 = require("../theme");
var Buttons_1 = require("./Buttons");
/**
 * The toast queue component that manages the display of toasts.
 * This component should not be used directly. Instead, use the toast queue API
 * to programmatically add toasts. The queue should be created once and used throughout the app.
 *
 * @example
 * ```tsx
 * const queue = new ToastQueue<ToastContent>();
 *
 * // Add a toast to the queue
 * queue.add({
 *   title: 'Success!',
 *   variant: 'success'
 * });
 * ```
 *
 * @see {@link https://react-spectrum.adobe.com/react-aria/Toast.html}
 */
exports.ToastQueue = react_aria_components_1.UNSTABLE_ToastQueue;
var StyledToastRegion = (0, styled_1.default)(react_aria_components_1.UNSTABLE_ToastRegion)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  gap: ", ";\n  position: fixed;\n  bottom: ", ";\n  right: ", ";\n  width: min(90vw, 480px);\n  min-width: 320px;\n  z-index: ", ";\n\n  ", " {\n    left: ", ";\n    right: ", ";\n    width: auto;\n  }\n"], ["\n  display: flex;\n  flex-direction: column;\n  gap: ", ";\n  position: fixed;\n  bottom: ", ";\n  right: ", ";\n  width: min(90vw, 480px);\n  min-width: 320px;\n  z-index: ", ";\n\n  ", " {\n    left: ", ";\n    right: ", ";\n    width: auto;\n  }\n"])), theme_1.theme.space.space16, theme_1.theme.space.space16, theme_1.theme.space.space16, theme_1.theme.zIndices.high, screenSizes_1.mediaMaxWidthSmall, theme_1.theme.space.space16, theme_1.theme.space.space16);
/**
 * The region where toasts will be displayed.
 * This component should not be used directly. Instead, use the toast queue API
 * to programmatically add toasts. The region should be rendered once in the root of your app.
 *
 * @example
 * ```tsx
 * // In your app's root component
 * <ToastRegion queue={queue}>
 *   {({ toast }) => <Toast toast={toast} />}
 * </ToastRegion>
 * ```
 *
 * @see {@link https://react-spectrum.adobe.com/react-aria/Toast.html}
 */
exports.ToastRegion = StyledToastRegion;
/**
 * The content wrapper for individual toast messages.
 * This component should not be used directly. Instead, use the toast queue API
 * to programmatically add toasts.
 *
 * @example
 * ```tsx
 * queue.add({
 *   title: 'Info',
 *   description: 'A new version is available',
 *   variant: 'info'
 * });
 * ```
 *
 * @see {@link https://react-spectrum.adobe.com/react-aria/Toast.html}
 */
exports.ToastContent = (0, styled_1.default)(react_aria_components_1.UNSTABLE_ToastContent)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n"], ["\n  display: flex;\n  flex-direction: column;\n"])));
var variantStyles = {
    info: {
        background: theme_1.theme.colors.surfacePrimary,
        border: theme_1.theme.colors.borderPrimary,
        color: theme_1.theme.colors.blue500,
        icon: icons_1.InfoCircleIcon,
    },
    success: {
        background: theme_1.theme.colors.surfacePositive,
        border: theme_1.theme.colors.borderPositive,
        color: theme_1.theme.colors.green500,
        icon: icons_1.SuccessIcon,
    },
    warning: {
        background: theme_1.theme.colors.surfaceWarning,
        border: theme_1.theme.colors.borderWarning,
        color: theme_1.theme.colors.bronze500,
        icon: icons_1.WarningIcon,
    },
    error: {
        background: theme_1.theme.colors.surfaceNegative,
        border: theme_1.theme.colors.borderNegative,
        color: theme_1.theme.colors.red500,
        icon: icons_1.ErrorIcon,
    },
};
var StyledToast = (0, styled_1.default)(react_aria_components_1.UNSTABLE_Toast)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  width: 100%;\n  min-width: 320px;\n  max-width: min(90vw, 560px);\n  justify-content: space-between;\n  background: ", ";\n  border: ", " solid\n    ", ";\n  border-radius: ", ";\n  padding: ", ";\n  gap: ", ";\n  position: relative;\n\n  ", " {\n    min-width: 0;\n    max-width: none;\n  }\n"], ["\n  display: flex;\n  align-items: center;\n  width: 100%;\n  min-width: 320px;\n  max-width: min(90vw, 560px);\n  justify-content: space-between;\n  background: ", ";\n  border: ", " solid\n    ", ";\n  border-radius: ", ";\n  padding: ", ";\n  gap: ", ";\n  position: relative;\n\n  ", " {\n    min-width: 0;\n    max-width: none;\n  }\n"])), function (props) { return variantStyles[props.variant].background; }, theme_1.theme.borderWidths.thick, function (props) { return variantStyles[props.variant].border; }, theme_1.theme.radii.field, theme_1.theme.space.space16, theme_1.theme.space.space16, screenSizes_1.mediaMaxWidthSmall);
/**
 * The main toast component that renders individual toast messages.
 * This component should not be used directly. Instead, use the toast queue API
 * to programmatically add toasts.
 *
 * Content properties:
 * - title: The main message to display in the toast
 * - description: Optional additional content to display below the title
 * - variant: Optional visual style variant for the toast ('info', 'success', 'warning', 'error'). Defaults to 'info'
 *
 * @example
 * ```tsx
 * queue.add({
 *   title: 'Warning',
 *   description: 'Please review your changes',
 *   variant: 'warning'
 * });
 * ```
 *
 * See the [React Aria Toast documentation](https://react-spectrum.adobe.com/react-aria/Toast.html) or the [Toast component stories](https://compass.circleci.com/?path=/story/rac-toast--default) for more information.
 */
var Toast = function (_a) {
    var _b;
    var toast = _a.toast;
    var variant = (_b = toast.content.variant) !== null && _b !== void 0 ? _b : 'info';
    var Icon = variantStyles[variant].icon;
    var color = variantStyles[variant].color;
    return (React.createElement(StyledToast, { toast: toast, variant: variant },
        React.createElement(Flex_1.Flex, { gap: "space12" },
            React.createElement(Icon, { color: color }),
            React.createElement(exports.ToastContent, null,
                React.createElement(Typography_1.H6, { color: 'contentPrimary' }, toast.content.title),
                React.createElement(Typography_1.BodyText, { color: 'contentPrimary' }, toast.content.description))),
        React.createElement(Buttons_1.IconButton, { onDarkBackground: false, size: "small", slot: "close", style: { alignSelf: 'flex-start' } },
            React.createElement(icons_1.CancelIcon, { color: "contentPrimary" }))));
};
exports.Toast = Toast;
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=Toast.js.map